import { useAppSelector } from "@/store";

export const DEVELOPER_ROLES = [
    // Legacy role name, can be deleted after LSSA-5558 is resolved
    "Developers",
    // New role names
    "Developer",
    "Developer - Combined",
];

export const useIsDeveloper = () => {
    const isDeveloper = useAppSelector((state) => DEVELOPER_ROLES.includes(state.user.primaryCombinedRole.name));
    return isDeveloper;
};
